// eslint-disable-next-line no-restricted-imports
import { useFlags } from 'launchdarkly-react-client-sdk';
import { z } from 'zod';

export type FeatureFlag = z.infer<typeof featureFlag>;
export const featureFlag = z.enum(['rbac-api-docs']);

export const useIsFeatureFlagEnabled = (
  feature: FeatureFlag | undefined,
): boolean => {
  const features = useFlags<Record<FeatureFlag, boolean>>();

  if (typeof feature === 'string') {
    const result = featureFlag.safeParse(feature);
    if (!result.success) {
      return false;
    }

    return features[result.data] ?? false;
  }

  return true;
};
